import styled from 'styled-components'
import { motion } from '@/theme/tokens'
import { Pill } from '@components/Pill'

/** The attachment count on an event card: a soft pill that opens the viewer, so it renders `as="button"`. */
export const IndicatorButton = styled(Pill).attrs({ $tone: 'soft' as const })`
	cursor: pointer;
	transition: filter ${motion.fast};

	svg {
		width: 12px;
		height: 12px;
		fill: currentColor;
	}

	&:hover {
		filter: brightness(0.97);
	}
`
